import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Nsba_member } from '../models/nsba_member';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class NsbaMemberSearchService {

	constructor(private http: HttpClient) { }

	getByTerm(term: string): Promise<Nsba_member[]> {
		return this.getWithRest("term/" + term);
	}

	private getWithRest(rest_url: string) : Promise<Nsba_member[]> {
	  	return new Promise((resolve, reject) => {

	  		return this.http.get(AppSettings.API_ENDPOINT + 'nsba_member_search/' + rest_url).subscribe((response:any) => {
				if(response.type == 'search_results' && response.data){
					resolve(response.data);
				} else {
					reject(response);
				}

			},
				error_response => {
		      		if(error_response instanceof HttpErrorResponse){
		      			reject(error_response.error);
		      		}
		      		reject(error_response);
				});


	  	});
	  }

}
